import { render, staticRenderFns } from "./AutomaticScansWidget.vue?vue&type=template&id=5fe9e2da&scoped=true"
import script from "./AutomaticScansWidget.vue?vue&type=script&lang=js"
export * from "./AutomaticScansWidget.vue?vue&type=script&lang=js"
import style0 from "./AutomaticScansWidget.vue?vue&type=style&index=0&id=5fe9e2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9e2da",
  null
  
)

export default component.exports